import { Component, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MSMEParticipantListForInvoice } from '../../../../../shared/models/MSMEParticipantListForInvoice';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-viewinvoicedetails',
  templateUrl: './viewinvoicedetails.component.html',
  styleUrl: './viewinvoicedetails.component.css'
})
export class ViewinvoicedetailsComponent implements AfterViewInit, OnDestroy {

  eventId: any = sessionStorage.getItem('EventId');
  invoiceStatusForm: FormGroup;
  statusList: any[] = [];
  showButton = false;
  msmeList: any[] = [];
  verified!: number;
  nonEligible!: number;
  unVerifiedMSMECount!: number;
  noOfMSMEAttended!: number;

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<MSMEParticipantListForInvoice>;

  displayedColumns = ['rowNum', 'udyamRegistrationNumber', 'udyamMobileNumber', 'enterpriseName', 'ownerName', 'participantName', 'mobileNumber', 'emailId', 'designation', 'enrollmentId'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);

  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  allrecord: any[] = [];

  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageIndex = 0;
  pageEvent!: PageEvent;

  mobile = sessionStorage.getItem('mobile');

  DtoPagination = {
    EventId: this.eventId,
    PageNumber: 1,
    PageSize: 20,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: ''
  };



  constructor(
    private apiService: ApiService,
    private toastrService: ToastrService,
    public dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    public commonService: CommonService,
    private fb: FormBuilder
  ) {
    this.invoiceStatusForm = this.fb.group({
      id: [''],
      invoiceID: [''],
      eventId: [''],
      ratePerMSME: [''],
      noOfMSMEAttended: [''],
      verified: [''],
      nonEligible: [''],
      unVerifiedMSMECount: [''],
      gstType: [''],
      gstPercent: [''],
      total: [''],
      totalGST: [''],
      finalTotal: [''],
      invoiceFileName: [''],
      invoiceFilePath: [''],
      invoiceAccepted: [''],
      paymentDate: [''],
      paymentMode: [''],
      utrNumber: [''],
      amount: [''],
      status: [''],
      statusName: [''],
      eventName: [''],
      date: [''],
      eventStatus: [''],
      intervention: [''],
      component: ['']
    });
  }


  async ngOnInit(): Promise<void> {
    this.LoadInvoiceStatusData();
  }


  LoadInvoiceStatusData() {

    var dtoEventId = {
      EventId: this.eventId,
      Mobile: this.mobile
    };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSDATAFORMSSIDC, dtoEventId).subscribe((result) => {

      if (result.status) {

        this.invoiceStatusForm.disable();
        this.invoiceStatusForm.patchValue(result.data);
        this.verified = result.data.verified;
        this.nonEligible = result.data.nonEligible;
        this.unVerifiedMSMECount = result.data.unVerifiedMSMECount;
        
        
        if (result.data.statusName !== 'Pending') {
          this.showButton = false;
        } else {
          this.showButton = true;
        }

        const paymentDate = new Date(result.data.date);
        const formattedPayementDate =
          `${paymentDate.getFullYear()}-${(paymentDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${paymentDate.getDate()
              .toString()
              .padStart(2, '0')}`;

        this.invoiceStatusForm.get('date')?.setValue(formattedPayementDate);
      }
    });
  }


  onCancel() {
    this.router.navigate(['/invoicedashboardmssidc']);
  }


  onInvoiceAccept() {

    var dtoUpdateInvoiceAcceptance = {
      InvoiceID: this.invoiceStatusForm.get('invoiceID')?.value,
      InvoiceAccepted: true,
      Mobile: this.mobile
    };

    this.apiService.postRequest(API_ENDPOINTS.MASTERS.INVOICE.UPDATEINVOICEACCEPTANCESTATUS, dtoUpdateInvoiceAcceptance).subscribe((result) => {

      if (result.status) {
        this.invoiceStatusForm.disable();
        this.invoiceStatusForm.patchValue(result.data);
      }
    });

    this.router.navigate(['/invoicedashboardmssidc']);
    this.toastr.success('Invoice Accepted Successfully.');
  }


  onInvoiceReject() {

    var dtoUpdateInvoiceAcceptance = {
      InvoiceID: this.invoiceStatusForm.get('invoiceID')?.value,
      InvoiceAccepted: false,
      Mobile: this.mobile
    };

    this.apiService.postRequest(API_ENDPOINTS.MASTERS.INVOICE.UPDATEINVOICEACCEPTANCESTATUS, dtoUpdateInvoiceAcceptance).subscribe((result) => {

      if (result.status) {
        this.invoiceStatusForm.disable();
        this.invoiceStatusForm.patchValue(result.data);
      }
    });

    this.router.navigate(['/invoicedashboardmssidc']);
    this.toastr.error('Invoice has been Rejected.');
  }


  onDownloadInvoice() {

    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;

    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName || 'download';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      }
    });
  }


  openFilePreviewDialog(): void {

    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {

        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }


  ngAfterViewInit() {
    this.loadData();
  }


  loadData() {

    if (!this.pagination) return;

    this.loadDataSubscription.unsubscribe();

    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {

          this.pagination.pageIndex = 0;

          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(
            API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA,
            this.DtoPagination
          ).pipe(catchError(() => of(null)));
        }),
        map(resp => {

          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }

          return resp?.data || {};
        })
      )
      .subscribe(data => {

        this.dataSource = data;
        this.adjustPaginator();
      });
  }


  adjustPaginator() {

    const totalPages = Math.ceil(this.length / this.pageSize);

    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1;
      this.DtoPagination.PageNumber = this.pageIndex + 1;
    }

    this.pagination.pageIndex = this.pageIndex;
  }


  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;

    this.loadData();
  }


  ngOnDestroy() {

    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  exportToExcel(): void {

    const payload = {
      eventId: this.eventId,
      pageNumber: 1,
      pageSize: 9999999,
      sortColumn: "",
      sortDirection: "",
      searchTerm: "",
      searchCol: this.commonService.searchText,
      isExport: true
    };

    this.apiService.postRequest(
      API_ENDPOINTS.MASTERS.INVOICE.EXPORTTOEXCELADDEDDCOLUMNS,
      payload
    ).subscribe({

      next: (result) => {

        if (!result.status || !result.data || result.data.length === 0) {
          this.toastrService.error("No data available to export.");
          return;
        }

        const records = result.data;
        const invoiceId = records[0].invoiceId || "Invoice";

        const excelData = records.map((item: any, index: any) => ({
          'Sr No': index + 1, 'Invoice ID': item.invoiceId, 'Invoice Date': item.invoiceDate, 'Event ID': item.eventId, 'Event Date': item.eventDate, 'Event Venue': item.eventVenue, 'Event District': item.eventDistrict, 'Intervention': item.intervention, 'Component': item.component, 'Udyam Registration Number': item.udyamRegistrationNumber, 'Udyam Mobile Number': item.udyamMobileNumber, 'Enterprise Name': item.enterpriseName, 'Owner Name': item.ownerName, 'Participant Name': item.participantName, 'Mobile Number': item.mobileNumber, 'Email ID': item.emailId, 'Designation': item.designation, 'Enrollment ID': item.enrollmentId
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

        const workbook: XLSX.WorkBook = {
          Sheets: { 'Invoice MSME List': worksheet },
          SheetNames: ['Invoice MSME List']
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        this.saveExcelFile(excelBuffer, `${invoiceId}.xlsx`);
        this.toastrService.success("Excel exported successfully!");
      },

      error: () => {
        this.toastrService.error("Unable to export Excel. Try again.");
      }
    });
  }


  saveExcelFile(buffer: any, fileName: string): void {

    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    saveAs(data, fileName);
  }

}
